import { useState, type FormEvent } from 'react'
import { ArrowRight } from 'lucide-react'
import { ApiError, login } from '../api'
import { Button, Field } from '../components'
import { CampaignBrand } from '../CampaignBrand'

export function LoginPage({ onSuccess }: { onSuccess: () => Promise<void> }) {
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const submit = async (event: FormEvent) => {
    event.preventDefault()
    setLoading(true)
    setError('')
    try {
      await login(email, password)
      await onSuccess()
    } catch (caught) {
      setError(caught instanceof ApiError ? caught.message : 'Não foi possível entrar')
    } finally { setLoading(false) }
  }

  return (
    <main className="login-page">
      <section className="login-panel">
        <CampaignBrand />
        <div className="login-copy">
          <h1>Acessar entregas</h1>
          <p>Entre com seu e-mail e senha para continuar.</p>
        </div>
        <form onSubmit={submit}>
          <Field label="E-mail" type="email" autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} required />
          <Field label="Senha" type="password" autoComplete="current-password" value={password} onChange={(event) => setPassword(event.target.value)} required />
          {error ? <div className="form-alert" role="alert">{error}</div> : null}
          <Button type="submit" loading={loading}>Entrar <ArrowRight size={16} /></Button>
        </form>
      </section>
    </main>
  )
}
